export default {
  SET_COUPONS ( state, payload){
    state.coupons = payload
  },
  SET_CURRENT_PAGE(state, payload){
    state.currentPage = payload;
  }
}
